import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass border-b border-[#E8E1DA]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-24 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center"
        >
          <img
            src="/brand/face-it-logo.jpg"
            alt="Face It Aesthetics by Nurse Dimi"
            className="h-16 sm:h-20 w-auto rounded-xl"
          />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-[#2C2723]/80 hover:text-[#8C6A53] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="book-now-header"
            className="btn-luxe hidden sm:inline-flex items-center px-6 py-3 rounded-full border border-[#2C2723] text-[#2C2723] hover:text-white text-sm tracking-wide"
          >
            Book Consultation
          </a>
          <button
            data-testid="menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden p-2 rounded-full border border-[#E8E1DA]"
            aria-label="Toggle menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-[#E8E1DA]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base text-[#2C2723]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center px-6 py-3 rounded-full bg-[#2C2723] text-white text-sm"
            >
              Book Consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
